import orgContainer from '@Components/AppContainer';
import InnerComponent from '@Components/Home/PendingInvoices';

const PendingInvoices = () => ((orgContainer(InnerComponent)));

export default PendingInvoices;
